<div class="ag-tooltip valid-tooltip">
  <span *ngFor="let tip of tooltip">{{tip}}<br></span>
</div>
